import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    createTableQr as createTableQrApi,
    deleteTableQr as deleteTableQrApi,
    getTableQrs as getTableQrsApi,
    resolveTableQr as resolveTableQrApi,
    verifyTableQr as verifyTableQrApi,
} from "../../helpers/backend_helper";

export const getTableQrs = createAsyncThunk("TableQrs/getTableQrs", async (_: void, { rejectWithValue }) => {
    try {
        return await getTableQrsApi();
    } catch (error) {
        return rejectWithValue(error);
    }
});

export const createTableQr = createAsyncThunk("TableQrs/createTableQr", async (payload: { table_id: string | number }, { rejectWithValue }) => {
    try {
        return await createTableQrApi(payload);
    } catch (error) {
        return rejectWithValue(error);
    }
});

export const deleteTableQr = createAsyncThunk("TableQrs/deleteTableQr", async (id: string | number, { rejectWithValue }) => {
    try {
        await deleteTableQrApi(id);
        return { id };
    } catch (error) {
        return rejectWithValue(error);
    }
});

export const resolveTableQr = createAsyncThunk("TableQrs/resolveTableQr", async (token: string, { rejectWithValue }) => {
    try {
        return await resolveTableQrApi(token);
    } catch (error) {
        return rejectWithValue(error);
    }
});

export const verifyTableQr = createAsyncThunk("TableQrs/verifyTableQr", async (payload: { url: string }, { rejectWithValue }) => {
    try {
        return await verifyTableQrApi(payload);
    } catch (error) {
        return rejectWithValue(error);
    }
});
